import React from 'react'
import NavMobile from '../../components/nav-mobile/NavMobile'
import CoverMobile from '../../components/CoverMobile/CoverMobile'
import CarouselProfesional from '../../components/carousel-professional/CarouselProfesional'
import { CategoriesTop } from '../../shared/categories-top/CategoriesTop'
import { HowUse } from '../../shared/how-use/HowUse'

export default function HomeMobile() {
  return (
    <div>

      <NavMobile />
      <CoverMobile />

      <div className="container">
        <div className="banner-hero"
          style={{
            position: "initial",
            marginTop: "20px",
            marginRight: "10px",
            width: "100%"
          }}
        >
          <div className="content-banner">

            <div className="balls">
              <div className="active"></div>
              <div></div>
              <div></div>
            </div>
            <p>Encuentra lo ideal para tu bienestar.</p>
            <h2 style={{ fontSize: "40px" }}>Tu salud es tu mayor prioridad</h2>

            <div className="call-btn"
              style={{ width: "80%", fontSize: "14px" }}
            >
              Buscar profeisonales

              <button className="btn btn-secondary">
                <img src="/assets/icons/right-arrow.svg" alt="" />
              </button>
            </div>
          </div>


        </div>
      </div>

      <br />
      <br />
      <CarouselProfesional />

      <br />
      <br />

      <div className="container">
        <div className="banner" style={{ background: "#b0ffff", margin: "0" }}>

        </div>

      </div>

      <br />
      <br />

      <CategoriesTop />

      <div className="container">
        <div className="banner" style={{ background: "#f4e200", margin: "0" }}>

        </div>

      </div>

      <br />
      <br />

      <HowUse />

    </div>
  )
}
